import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function InfoIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "info";
  const color = props.color || defaultColor;
  return (
    <SvgIcon
      {...props}
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      enableBackground="new 0 0 24 24"
      titleAccess="Info"
    >
      <circle
        cx="11"
        cy="11"
        r="11"
        transform="matrix(-1 8.74228e-08 8.74228e-08 1 23 1)"
      />
      <path
        d="M12 6.29248V6.25008"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.5425V18.5425"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
